import moment from "moment/moment";

export const getYear = (value) =>  moment(value).year();

export const getDate = (value) => moment(value).toDate()

export const dateDiff = (value, period) => moment().diff(value, period);

export const formatDate = (value) => moment(value).format('YYYY-MM-DD')